module.exports = __webpack_public_path__ + "static/media/visual art.eea7659a.jpg";